module.exports = __webpack_public_path__ + "img/2K.82741db0.png";